/* ------------------------------------------------------------
 * MOVENIA - Lookbooks au scroll, mode statique
 *
 * La section d'origine fonctionne en sticky : elle réserve une
 * hauteur de plusieurs écrans et c'est le scroll qui fait passer
 * d'un lookbook au suivant. Cette course se lit comme une zone
 * vide sous la section.
 *
 * Ici la section est ramenée à la hauteur de son contenu (voir
 * movenia-links.css) et la navigation passe par les puces.
 * Le script d'origine se désactive tout seul dans ce cas : sa
 * méthode update() sort immédiatement quand la course vaut zéro.
 * ------------------------------------------------------------ */

(function () {
  function setActive(root, index) {
    var groups = [
      '.lookbook-scroller__text',
      '.lookbook-scroller__media',
      '.lookbook-scroller__dot'
    ];

    groups.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (el) {
        var on = parseInt(el.dataset.index, 10) === index;
        el.classList.toggle('is-active', on);

        if (selector === '.lookbook-scroller__text') {
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) {
            el.removeAttribute('inert');
          } else {
            el.setAttribute('inert', '');
          }
        }

        if (selector === '.lookbook-scroller__dot') {
          el.setAttribute('aria-current', on ? 'true' : 'false');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('lookbook-scroller').forEach(function (root) {
      if (root.dataset.moveniaStatic === 'on') return;
      root.dataset.moveniaStatic = 'on';

      var dots = root.querySelectorAll('.lookbook-scroller__dot');
      if (dots.length < 2) return;

      dots.forEach(function (dot) {
        dot.addEventListener(
          'click',
          function (event) {
            // On coupe le handler d'origine, qui tenterait un scrollTo.
            event.stopImmediatePropagation();
            event.preventDefault();
            setActive(root, parseInt(dot.dataset.index, 10));
          },
          true
        );
      });

      // Dans l'éditeur de thème, sélectionner un bloc l'affiche.
      root.addEventListener('shopify:block:select', function (event) {
        var text = event.target.closest('.lookbook-scroller__text');
        if (text) setActive(root, parseInt(text.dataset.index, 10));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
